import {
  AssemblyModalities,
  AssemblyType,
  StepIds,
} from 'helpers/enums/Assembleia';

export const getAssemblySteps = (
  modality?: AssemblyModalities,
  type?: AssemblyType,
  reu?: boolean
) => {
  switch (modality) {
    case AssemblyModalities.OFFLINE:
    case AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL:
    case AssemblyModalities.HIBRIDO_SIMULTANEO:
      if (AssemblyType.AGN === type && !reu) {
        return [
          StepIds.data,
          StepIds.entity,
          StepIds.local,
          StepIds.staves,
          StepIds.survey,
          StepIds.attachment,
        ];
      }
      return [
        StepIds.data,
        StepIds.entity,
        StepIds.local,
        StepIds.staves,
        StepIds.attachment,
      ];
    case AssemblyModalities.ONLINE:
    case AssemblyModalities.HIBRIDO_DIGITAL_AGENCIA:
    default:
      if (AssemblyType.AGN === type && !reu) {
        return [
          StepIds.data,
          StepIds.entity,
          StepIds.staves,
          StepIds.survey,
          StepIds.attachment,
        ];
      }
      return [StepIds.data, StepIds.entity, StepIds.staves, StepIds.attachment];
  }
};
